/*
 * @Author: your name
 * @Date: 2021-05-08 11:03:40
 * @LastEditTime: 2021-05-08 16:42:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ao-app-campaign/src/api/index.js
 */
import axios from 'axios'
import { Toast } from 'vant'
import Vue from 'vue'
import storeData from '../store/index'
// import share from '../common/share'
// import env from '../config/env'
const instance = axios.create({
  baseURL: '/',
  timeout: 10000,
})
// 添加请求拦截器
instance.interceptors.request.use(
  function(config) {
    config.headers['content-type'] = 'application/json;charset=UTF-8'
    let token = storeData.state.wxLogin.wxToken
    console.log('storeData',storeData.state.wxLogin)
    console.log('token',token)
    // if (token) {
    //   config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    //   config.headers['authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
    // }
    if (token) {
      config.headers['Content-Type']='application/x-www-form-urlencoded',
      config.headers['customAuthorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    console.log(process.env.NODE_ENV)
    if (process.env.NODE_ENV === 'development') {
      if (config.url.indexOf('hotwater') === -1) {
        config.url = 'api/' + config.url
      }
    }
    return config
  },
  function(error) {
    // 对请求错误做些什么
    Toast.fail(typeof error === 'string' ? error : JSON.stringify(error))
    return Promise.reject(error)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  function(response) {
    return response
  },
  async function(error) {
    // 对响应错误做点什么
    if (error.response.status === 500) {
      Toast.fail('服务繁忙')
    } else if (error.response.status === 401) {
        console.log('401')
         Vue.ls.remove("ssToken")
         Vue.ls.remove('ssOpenId')
        // storeData.commit('wxLogin/setWxCode', "")
        // storeData.commit('wxLogin/setWxToken', "")
        // window.location.reload();
    } else {
      Toast.fail(
        error.response.data.error || error.response.data.message || '服务繁忙'
      )
    }
    return Promise.reject(error)
  }
)
export default instance
